.modalButtons {
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
	max-width: 100%;
}

.modalButton {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	width: 100%;
	background-color: #6a6d70;
	color: #ffffff;
	font-family: BourgeoisUltra, "Arial Regular", Arial, sans-serif;
	font-weight: 700;
	font-size: 1.125rem;
	text-transform: uppercase;
	line-height: 1.375rem;
	padding: 11.5px 1rem;
	border-radius: 11px;
	border: none;
	cursor: pointer;

	&:hover {
		background-color: #7e7f81;
	}

	span {
		line-height: 1;
		margin-bottom: -5px;
	}

	img {
		filter: brightness(0) invert(1);
	}
}
